<div class="wrapper">
  <div class="section">
    <div
      style="display: flex; align-items: center; gap: 0.5rem"
      class="sub-title required"
    >
      <mat-icon
        *ngIf="
          getErrors(insideSurveyInsideInfo.TSA_TECHNICALSOLUTION_NOT_PROVIDED)
        "
        style="color: red"
      >
        warning
      </mat-icon>
    </div>
    <div class="error-message" *ngIf="showErrorMessage">
      <p>
        Unable to change the No Admin TSA questions, because the TSA/No Admin
        TSA was already printed/sent
      </p>
    </div>
  </div>
  <div
    class="section question-section"
    *ngIf="noAdminTSAForm"
    [formGroup]="noAdminTSAForm"
  >
    <div class="questions">
      <div class="form-line checkbox-align-left">
        <p-radioButton
          class="radio-button-margin"
          formControlName="tsaType"
          [disabled]="arecheckboxesReadOnly"
          value="2"
        ></p-radioButton>
        <span class="checkbox-align-center">NO TSA - Use if TSA isn’t required (ex. Quadrant D without BDFO)</span>
      </div>
      <div class="form-line checkbox-align-left">
        <p-radioButton
          class="radio-button-margin"
          formControlName="tsaType"
          [disabled]="arecheckboxesReadOnly"
          value="1"
        ></p-radioButton>
        <span class="checkbox-align-center">NO ADMIN TSA - Use as the best default option</span>
      </div>
      <div class="form-line checkbox-align-left">
        <p-radioButton
          class="radio-button-margin"
          formControlName="tsaType"
          [disabled]="arecheckboxesReadOnly"
          value="0"
        ></p-radioButton>
        <span class="span-align-center">
          TSA - Only use if:<br />
          • The technical solution will be very complex and outside of the usual
          proposals<br />
          • There are aesthetic reasons that could complicate the current
          proposal of a technical solution.<br />
          • There Will Be A Heavy Impact On The Habitants Of The Lu’s (Large
          Construction Works Etc.)</span
        >
      </div>
    </div>
  </div>
</div>
